import { LoadboardMap, LoadboardStop } from "@/components/dataPages/loadboard";

export const LoadboardMapSection = ({ load, isOpen }) => {
    return (
        <div className="w-full lg:w-[42.674254%] bg-cm-p-surface rounded-lg flex flex-row p-4">
            <LoadboardMap stops={load.itineraryStops} isOpen={isOpen} id={load.uniqueId} />
            <div className="flex flex-col flex-1 gap-2 overflow-auto pl-[28px]">
                {load.itineraryStops.map((stop, index) => (
                    <LoadboardStop stop={stop} key={index} first={index === 0} last={load.itineraryStops.length - 1 === index} />
                ))}
            </div>
        </div>
    );
};
